var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "3.53306017%",
    x2: "100%",
    y2: "96.4669398%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B87F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BBA58",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0.820005895%",
    x2: "100%",
    y2: "99.1799941%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B87F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BBA58",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.7342031%",
    y1: "0%",
    x2: "66.2657969%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B87F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BBA58",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "25.3141686%",
    x2: "100%",
    y2: "74.6858314%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B87F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BBA58",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pages-/-desktop-/-muziekbeheer---1-instellingen---5-thema---2",
    transform: "translate(-557.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(490.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tunify-spot",
    transform: "translate(20.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "images-/-select-/-muziekagenda",
    transform: "translate(47.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background",
    transform: "translate(52.830000, 60.999550) rotate(-180.000000) translate(-52.830000, -60.999550) ",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "url(#linearGradient-1)",
    points: "0 30.499 0 80.619 49.23 93.809 97.31 45.719 90.96 22.009 52.83 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "url(#linearGradient-2)",
    points: "0 30.499 0 52.259 30.33 104.79 82.641 104.79 105.66 91.499 105.66 30.499 52.83 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "url(#linearGradient-3)",
    points: "0 91.4992 13.17 99.0992 37.53 74.7392 28.47 40.9292 0 33.2992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "url(#linearGradient-4)",
    points: "28.6497 56.0491 6.1407 95.0401 52.8297 121.9991 99.9997 94.7591 77.6507 56.0491"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(33.000000, 42.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5904,33.352 L28.5904,35.2592 L24.2096,35.2592 C25.08,39.2464 28.4112,42.3632 32.5296,42.8304 C36.9244408,43.3350857 41.1442506,40.7291315 42.6803132,36.6098135 L42.7728,36.3504 L44.5808,36.9648 C42.9776,41.6624 38.4848,44.7984 33.6048,44.7984 C33.176,44.7984 32.744,44.7728 32.3152,44.728 C28.094322,44.2440976 24.5739793,41.4392909 22.9843805,37.6537347 L22.8688,37.368 L22.8688,40.9776 L20.9648,40.9776 L20.9648,33.352 L28.5904,33.352 Z M11.4336,-8.66862138e-14 L11.4336,2.8544 L28.5888,2.8544 L28.5888,-8.66862138e-14 L30.496,-8.66862138e-14 L30.496,2.8544 L37.1648,2.8544 C38.6860571,2.8544 39.9305918,4.04757959 40.0175468,5.547343 L40.0224,5.7152 L40.0224,18.1024 L38.1184,18.1024 L38.1184,14.2944 L1.904,14.2944 L1.904,32.3968 C1.904,32.8841143 2.27373061,33.2886531 2.74673353,33.343958 L2.8576,33.3504 L18.1056,33.3504 L18.1056,35.2576 L2.8576,35.2576 C1.33634286,35.2576 0.0918081633,34.0644204 0.004853207,32.564657 L1.07434062e-12,32.3968 L1.07434062e-12,5.7152 C1.07434062e-12,4.19394286 1.19020408,2.94643265 2.68975496,2.85926516 L2.8576,2.8544 L9.5296,2.8544 L9.5296,-8.66862138e-14 L11.4336,-8.66862138e-14 Z M22.12704,27.8384 C23.86784,22.728 29.02944,19.464 34.38944,20.0752 C38.71264,20.5648 42.30304,23.5024 43.83584,27.4288 L43.83584,27.4288 L43.83584,23.8224 L45.74304,23.8224 L45.74304,31.4448 L38.11744,31.4448 L38.11744,29.5408 L42.49504,29.5408 C41.62784,25.5536 38.29664,22.4368 34.17184,21.9664 C29.69184,21.4608 25.38464,24.184 23.92864,28.4528 L23.92864,28.4528 Z M9.5296,4.7616 L2.8576,4.7616 C2.37028571,4.7616 1.96574694,5.13133061 1.91044198,5.60433353 L1.904,5.7152 L1.904,12.3872 L38.1184,12.3872 L38.1184,5.7152 C38.1184,5.22788571 37.7486694,4.82334694 37.2756665,4.76804198 L37.1648,4.7616 L30.496,4.7616 L30.496,9.5296 L28.5888,9.5296 L28.5888,4.7616 L11.4336,4.7616 L11.4336,9.5296 L9.5296,9.5296 L9.5296,4.7616 Z",
    id: "icon-/-muziekagenda's"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicAgenda);
export default __webpack_public_path__ + "static/media/musicAgenda.2b9de7d088a383be26b3bb2018c9f936.svg";
export { ForwardRef as ReactComponent };